import styles from './CustomFormRequiredMark.module.scss';

export const customizeRequiredMark = (
	label: React.ReactNode,
	{ required }: { required: boolean },
) => (
	<>
		{label}
		{required ? <div className={styles.requiredMark}>*</div> : null}
	</>
);
